import React from "react";
import PrivateLayout from "../../layouts/PrivateLayout";
import { useNavigate } from "react-router-dom";

function SoloDuoRanking() {
  const backgroundImage = "/ww-wallpaper.webp";
  const navigate = useNavigate();

  const handleShowStandings = () => {
    navigate("/solo-duo-ranking/standings");
  };

  const handleManageRegistration = () => {
    navigate("/solo-duo-ranking/manage-registration");
  };

  return (
    <PrivateLayout backgroundImage={backgroundImage}>
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-4rem)] text-center text-white bg-black/40 px-4">
        <h1 className="text-3xl md:text-5xl font-bold mb-4 drop-shadow-lg">
          Solo/Duo Ranking
        </h1>
        <p className="text-lg md:text-xl max-w-2xl drop-shadow mb-6">
          Solo and duo ladder rankings will appear here. Use the buttons below
          to explore different Solo/Duo sections.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-6">
          <button
            type="button"
            onClick={handleShowStandings}
            className="px-5 py-2 rounded-full text-sm md:text-base font-semibold shadow-md transition-colors bg-blue-500 hover:bg-blue-400"
          >
            Standings
          </button>

          <button
            type="button"
            onClick={handleManageRegistration}
            className="px-5 py-2 rounded-full text-sm md:text-base font-semibold shadow-md transition-colors bg-emerald-500 hover:bg-emerald-400"
          >
            Manage registration
          </button>
        </div>
      </div>
    </PrivateLayout>
  );
}

export default SoloDuoRanking;